export function getSearchLocale(locale?: string) {
  return locale ? `/${locale}` : "";
}
